import pb, {
	type FormatOptions,
	ResizeType,
} from "@bitpatty/imgproxy-url-builder";

export function getImageUrl(
	src: string,
	{
		format,
		width,
		height,
		quality,
		maxBytes,
	}: {
		format?: FormatOptions;
		width?: number;
		height?: number;
		quality?: number;
		maxBytes?: number;
	},
) {
	const baseUrl = "https://cdn-assets.scarf.club";
	const salt = "48bd2a32b1cfe4f2be2e396ac27595e0";
	const key = "76baf2f34b7848121f080adcdb7f5789";

	let url = pb();

	if (width || height) {
		url = url.resize({
			width,
			height,
			type: ResizeType.AUTO,
		});
	}

	if (format) {
		url = url.format(format);
	}

	if (quality) {
		url = url.quality(quality);
	}

	if (maxBytes) {
		url = url.maxBytes(maxBytes);
	}

	return url.build({
		path: src,
		signature: {
			salt,
			key,
		},
		baseUrl,
	});
}
